import { React } from 'react';

export default function PrivacyStatement() {
    return (
        <div className="grid fixed h-screen lg:mt-0 right-0 w-full custom-width-lg justify-center overflow-y-scroll custom-scrollbar">
            {/* Privacy Statement Title */}
            <div className="text-center mt-28 lg:mt30 text-3xl text-white font-calibri font-medium">
                Privacy Statement
            </div>

            {/* Privacy Statement Content */}
            <div className="mt-12 mx-12 sm:mx-28 md:mx-36 lg:mx-48 text-medium text-white font-calibri whitespace-pre-line">
                <p>This application does not require the collection of any personal information.</p> <br></br>
                <p>However, despite this, students could accidentally enter personal information into the tool while using it.</p> <br></br>
                <p>Students are encouraged to contact their instructor and/or their program area for information and guidance on how to safely use this tool and reduce the risk of inadvertent disclosure of personal information.</p> <br></br>
                <p>Students may also contact <a href="mailto:privacy@jibc.ca" className="text-white underline">privacy@jibc.ca</a> if they have any questions or concerns about the use of this tool.</p> <br></br>
            </div> 
        </div>
    )
}

